import { property as propertyGlobals } from '@luxuryescapes/lib-global';

export default function getPropertyTypeName(type?: string) {
  if (type === propertyGlobals.UNIQUE_STAYS_TYPE) {
    return 'Unique Stays';
  }

  if (type === propertyGlobals.RENTAL_TYPE) {
    return 'Rental';
  }

  return 'Hotel';
}
